import { addDays, isoWeekday, today } from '@squadcore/api/shared/time'
import type { QueryClient } from '@tanstack/react-query'
import { sessionQuery } from '~/lib/session'

// Route loaders use these outside the lazy page chunks, so this module stays free of components.

/** Monday-based week containing `week` (or today), as [from, to) calendar days. */
export function weekBounds(week: string | undefined, tz: string) {
  const anchor = week ?? today(tz)
  const from = addDays(anchor, 1 - isoWeekday(anchor))
  return { from, to: addDays(from, 7) }
}

const WINDOW_DAYS = 70

/** The visible duty window: the next ten weeks, or the last ten weeks (newest first). */
export function dutiesWindow(tz: string, past: boolean) {
  const day = today(tz)
  return past
    ? { from: addDays(day, -WINDOW_DAYS), to: day, order: 'desc' as const }
    : { from: day, to: addDays(day, WINDOW_DAYS), order: 'asc' as const }
}

export async function dutiesRange(qc: QueryClient, past: boolean) {
  const session = await qc.ensureQueryData(sessionQuery)
  return dutiesWindow(session.active?.organization.timezone ?? 'Europe/Berlin', past)
}
